"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * TPC Enrollment
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PreBiographicInfoStepPutBodyToJSON = exports.PreBiographicInfoStepPutBodyFromJSONTyped = exports.PreBiographicInfoStepPutBodyFromJSON = void 0;
const runtime_1 = require("../runtime");
const _1 = require("./");
function PreBiographicInfoStepPutBodyFromJSON(json) {
    return PreBiographicInfoStepPutBodyFromJSONTyped(json, false);
}
exports.PreBiographicInfoStepPutBodyFromJSON = PreBiographicInfoStepPutBodyFromJSON;
function PreBiographicInfoStepPutBodyFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'firstName': json['firstName'],
        'middleName': !runtime_1.exists(json, 'middleName') ? undefined : json['middleName'],
        'noMiddleName': json['noMiddleName'],
        'lastName': json['lastName'],
        'suffix': !runtime_1.exists(json, 'suffix') ? undefined : json['suffix'],
        'gender': json['gender'],
        'dateOfBirth': (new Date(json['dateOfBirth'])),
        'overrideReason': !runtime_1.exists(json, 'overrideReason') ? undefined : _1.OverrideReasonFromJSON(json['overrideReason']),
    };
}
exports.PreBiographicInfoStepPutBodyFromJSONTyped = PreBiographicInfoStepPutBodyFromJSONTyped;
function PreBiographicInfoStepPutBodyToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'firstName': value.firstName,
        'middleName': value.middleName,
        'noMiddleName': value.noMiddleName,
        'lastName': value.lastName,
        'suffix': value.suffix,
        'gender': value.gender,
        'dateOfBirth': (value.dateOfBirth.toISOString().substr(0, 10)),
        'overrideReason': _1.OverrideReasonToJSON(value.overrideReason),
    };
}
exports.PreBiographicInfoStepPutBodyToJSON = PreBiographicInfoStepPutBodyToJSON;
//# sourceMappingURL=PreBiographicInfoStepPutBody.js.map